document.addEventListener('DOMContentLoaded', function() {
  const validationForm = document.querySelector('#membershipValidate');
  const validationMessage = document.querySelector('#validationMessage');

  if (validationForm) {
    validationForm.addEventListener('submit', function(event) {
      event.preventDefault();
  
      const fullName = document.querySelector('#member-fullname').value.trim().toUpperCase();
      const membershipId = document.querySelector('#member-number').value.trim();
  
      // Clear previous validation message
      validationMessage.textContent = '';
  
      // Validation
      if (!fullName || !membershipId) {
          addMessage('validationMessage', 'Please fill in both the Member Surname and Member Number.');
          return;
      }
  
      // Create Data Array
      const data = {
        fullName: fullName,
        membershipId: membershipId
      };
      
      // Validate Membership Details
      fetch('https://api.iwm.org.uk/v1/store-membership', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(data => {
        //console.log('Response:', data);
        if (data.status === 'OK') {
            //console.log('success');
            //console.log(data.membertype);
            //addMessage('validationMessage', 'Membership Validated Successfully');
            const fullNameCrm = data.fullname.trim().toUpperCase();
            //console.log(fullNameCrm);
          
            // Call to generateDiscount function
            const membershipIdFixed = membershipId.replace(/\s+/g, '');
            //const priceRuleTitle = `${fullName}_${membershipIdFixed}`;
            const memberfullNameId = `${fullNameCrm}_${membershipIdFixed}`;
            //console.log(memberfullNameId);
            generateDiscount(memberfullNameId, data.membertype);
        } else {
            //console.log('error', data);
            addMessage('validationMessage', 'Membership Validation Failed. ');
            addMessage('validationMessage', 'If you are require help in validating your membership, please <a href="https://www.iwm.org.uk/contact-us">contact customer services</a> or by telephone at 020 7091 3067 (Monday to Friday 9am to 5pm, standard call charges apply).');
          
        }
      })
      .catch(error => {
        //console.error('Error:', error);
      });
    });
  }
});

async function generateDiscount(memberfullNameId, membertype) {
  const shopifyAPI = axios.create({
      headers: {
      'X-Shopify-Access-Token': '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',
      'Content-Type': 'application/json'
    }
  });

  // Logic to work out % discount
  let discount;
  let priceRuleTitle;
  if (membertype == 'lifetime') {
    discount = '-15.0';
    priceRuleTitle = `${memberfullNameId}_15`;
  } else if (membertype == 'annual') {
    discount = '-10.0';
    priceRuleTitle = `${memberfullNameId}_10`;
  }

  const doesPriceRuleExist = async (title) => {
    try {
      const response = await shopifyAPI.get('https://api.iwm.org.uk/v1/membercodes');
      const priceRules = response.data.price_rules;
      const priceRule = priceRules.find(rule => rule.title === title);
      if (priceRule) {
        const dateStartsAt = new Date(priceRule.starts_at);
        const dateEndsAt = new Date(priceRule.ends_at);
        const dateNow = new Date();
        const dateStartsAtUnix = dateStartsAt.getTime();
        const dateEndsAtUnix = dateEndsAt.getTime();
        const dateNowUnix = dateNow.getTime();
        //console.log(dateStartsAt);
        //console.log(dateStartsAtUnix);
        //console.log(dateEndsAt);
        //console.log(dateEndsAtUnix);
        //console.log(dateNow);
        //console.log(dateNowUnix);
        //console.log(priceRule);
        const isActive = dateStartsAtUnix <= dateNowUnix && dateEndsAtUnix >= dateNowUnix;
        //console.log(isActive);
        if (isActive == false) {
          //console.log('this is false');
          await updatePriceRule(priceRule.id); // Call the updatePriceRule function here
        }
        //console.log(`Price Rule Status: ${isActive ? 'active' : 'inactive'}`);
      } else {
          //return false;
      }
      return priceRule ? priceRule.id : null;
    } catch (error) {
      //console.error('Error checking price rule:', error);
      return false;
    }
  };

  const endsAt = new Date();
  endsAt.setHours(endsAt.getHours() + 1); // Set to one hour later
  //console.log(endsAt);

  const createPriceRule = async (priceRuleTitle) => {
    const priceRuleData = {
      price_rule: {
        title: priceRuleTitle,
        target_type: 'line_item',
        target_selection: 'entitled',
        entitled_collection_ids: [648843428165],
        allocation_method: 'across',
        value_type: 'percentage',
        value: `${discount}`,
        customer_selection: 'all',
        starts_at: new Date().toISOString(),
        ends_at: endsAt.toISOString(),
        once_per_customer: false,
        combines_with: []
      }
    };

    //console.log(priceRuleData);

    const response = await shopifyAPI.post('https://api.iwm.org.uk/v1/membercodes', priceRuleData);
    return response.data.price_rule.id;
  };

  const createDiscountCode = async (priceRuleTitle, createPriceRuleAction = false, existingRuleId) => {
    //console.log(existingRuleId);
    //console.log(createPriceRule);
    const priceRuleId = await createPriceRule(priceRuleTitle);

    const discountCodeData = {
        discount_code: {
            price_rule_id: priceRuleId,
            code: priceRuleTitle,
            usage_count: 1
        }
    };

    const response = await shopifyAPI.post(`https://api.iwm.org.uk/v1/pricerules/${priceRuleId}`, discountCodeData);
    //console.log('Discount Code Created:', response.data.discount_code);
    // Apply Discount to cart
    applyDiscount(priceRuleTitle);
  };
  
  // Check if price rule exists
  const existingRuleId = await doesPriceRuleExist(priceRuleTitle);

  //console.log(existingRuleId);

  if (existingRuleId) {
    //console.log('Price rule already exists.');
    // Apply Discount to cart
    applyDiscount(priceRuleTitle);
  } else {
      //console.log('Price rule does not exist.');
      await createDiscountCode(priceRuleTitle, true, existingRuleId);
  }
}

async function applyDiscount(priceRuleTitle) {
  fetch(`/discount/${priceRuleTitle}`)
    .then(response => {
      //console.log('Discount Applied');
      addMessage('validationMessage', 'Your membership discount has been applied to your cart.');
      
      
// Select the element
const validationForm = document.querySelector('#membershipValidate');

// Hide the element
validationForm.style.display = 'none';

// Create the new paragraph
const newParagraph = document.createElement('p');
newParagraph.innerHTML = 'Your membership has validated successfully.<br/>Your discount code is valid for 1 hour.<br/>Please click the button below to apply this discount to your cart.';

// Create the new markup
const newMarkup = document.createElement('a');
newMarkup.href = '/cart';
newMarkup.textContent = 'Apply Discount To Cart';

newMarkup.classList.add('button-validate-membership');

// Wrap the <a> in a <p>
const linkWrapper = document.createElement('p');
linkWrapper.appendChild(newMarkup);

// Insert the new paragraph and link wrapper into the DOM
validationForm.parentNode.insertBefore(newParagraph, validationForm.nextSibling);
validationForm.parentNode.insertBefore(linkWrapper, newParagraph.nextSibling);

    })
    .catch(error => {
        console.error('Error applying discount:', error);
    });
}

async function updatePriceRule(priceRuleId) {
  const shopifyAPI = axios.create({
    baseURL: 'https://12c56e-0a.myshopify.com/admin/api/2025-04',
    headers: {
      'X-Shopify-Access-Token': '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',
      'Content-Type': 'application/json'
    }
  });
  const endsAt = new Date();
  endsAt.setHours(endsAt.getHours() + 1); // Set to one hour later
  console.log(endsAt);

  const priceRuleData = {
    price_rule: {
      starts_at: new Date().toISOString(),
      ends_at: endsAt.toISOString()
    }
  };

  try {
    const response = await shopifyAPI.post(`https://api.iwm.org.uk/v1/pricerules/${priceRuleId}`, discountCodeData);
    //console.log('Price Rule Updated:', response.data.price_rule);
    //addMessage('validationMessage', 'Price Rule Updated & Membership Validated Successfully');
  } catch (error) {
    //console.error('Error updating price rule:', error);
  }
}

// Function to add a new message as an <li> element to a specified container
function addMessage(containerId, message) {
  const container = document.querySelector(`#${containerId}`);
  if (container) {
    const li = document.createElement('li');
    li.innerHTML = message;
    container.appendChild(li);
  } else {
    //console.error(`Container with ID '${containerId}' not found.`);
  }
}
